/**
 * Inline tool that colors the selected text with a span[style="color: …"].
 * Replaces editorjs-text-color-plugin, whose picker doesn't render in this stack.
 * Accepts the same config keys: colorCollections, defaultColor.
 */
export default class TextColor {
    static get isInline() {
        return true;
    }

    static get title() {
        return 'Text Color';
    }

    static get sanitize() {
        return {
            span: {style: true},
            font: {color: true} // legacy content saved by the old plugin
        };
    }

    constructor({api, config}) {
        this.api = api;
        const cfg = config || {};
        this.colors = cfg.colorCollections || ['#FF1300', '#0070FF', '#4CAF50', '#000', '#4a4a4a', '#999'];
        this.defaultColor = cfg.defaultColor || '#4a4a4a';
        this.button = null;
        this.actions = null;
        this.range = null;
    }

    render() {
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.classList.add(this.api.styles.inlineToolButton);
        this.button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">'
            + '<path fill="currentColor" d="M11 3 5.7 16.5h2.4l1.2-3.2h5.4l1.2 3.2h2.4L13 3h-2zm-.9 8.3L12 5.6l1.9 5.7h-3.8z"/>'
            + '<rect x="4.5" y="18.5" width="15" height="3" rx="1" fill="' + this.defaultColor + '"/>'
            + '</svg>';
        return this.button;
    }

    renderActions() {
        this.actions = document.createElement('div');
        this.actions.style.cssText = 'display:none;flex-wrap:wrap;gap:4px;padding:6px;max-width:190px;';

        this.colors.forEach(color => {
            const swatch = document.createElement('button');
            swatch.type = 'button';
            swatch.style.cssText = 'width:18px;height:18px;border-radius:3px;border:1px solid rgba(0,0,0,0.15);cursor:pointer;padding:0;background-color:' + color + ';';
            swatch.title = color;
            swatch.addEventListener('mousedown', e => e.preventDefault()); // don't steal the text selection
            swatch.addEventListener('click', () => this.applyColor(color));
            this.actions.appendChild(swatch);
        });

        return this.actions;
    }

    surround(range) {
        if (range) this.range = range.cloneRange();
        this.actions.style.display = this.actions.style.display === 'none' ? 'flex' : 'none';
    }

    applyColor(color) {
        if (this.range) {
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(this.range);
        }

        document.execCommand('styleWithCSS', false, true);
        document.execCommand('foreColor', false, color);

        this.actions.style.display = 'none';
        this.api.inlineToolbar.close();
    }

    checkState() {
        const span = this.api.selection.findParentTag('SPAN');
        const active = !!(span && span.style && span.style.color);
        this.button.classList.toggle(this.api.styles.inlineToolButtonActive, active);
        return active;
    }

    clear() {
        if (this.actions) this.actions.style.display = 'none';
        this.range = null;
    }
}
